import React from "react";
import { Image, Modal } from "react-bootstrap";
import xclose from "../../assets/icons/x-close.svg";

export default function ApprovalCommentsModal({ show, onHide, approvalComments }) {

    const parseComments = (raw) => {
        if (!raw) return [];
        // Split by <b> tags to get each entry
        const parts = raw.split("<b>").filter(Boolean);
        return parts.map((part) => {
            const [header, ...bodyParts] = part.split("</b>");
            const body = bodyParts.join("</b>").replace(/<br>/g, "").replace(/\r\n/g, "\n").trim();
            const headerClean = header.replace(/<br>/g, "").replace(/\r\n/g, "").trim();
            const pipeIdx = headerClean.indexOf("|");
            const dateTime = pipeIdx > -1 ? headerClean.substring(0, pipeIdx).trim() : "";
            const rest = pipeIdx > -1 ? headerClean.substring(pipeIdx + 1).trim() : headerClean;
            const bracketMatch = rest.match(/^([^[]*?)\[([^\]]+)\]\s*:\s*$/);
            const name = bracketMatch ? bracketMatch[1].trim() : rest.replace(/:$/, "").trim();
            const action = bracketMatch ? bracketMatch[2] : "";
            return { dateTime, name, action, body };
        }).filter(entry => entry.dateTime);
    };

    const checkUpdates = async (e) => {
        e.preventDefault();
        onHide();
    };


    const entries = parseComments(approvalComments);

    return (
        <Modal show={show} onHide={onHide} size="lg" centered className="remark-history-modal">
            <Modal.Header className="remark-history-modal-header">
                <Modal.Title className="remark-history-modal-title">Approval Comments</Modal.Title>
                <Image src={xclose} onClick={checkUpdates} ></Image>
            </Modal.Header>
            <Modal.Body className="remark-history-modal-body">
                <div className="remark-history-timeline">
                    {entries.map((entry, idx) => (
                        <div className="remark-history-item" key={idx}>
                            <div className="remark-timeline-dot"></div>
                            {idx < entries.length - 1 && <div className="remark-timeline-line"></div>}
                            <div className="remark-history-content">
                                <span className="remark-history-date">{entry.dateTime}</span>
                                <span className="remark-history-name">{entry.name} {entry.action && `(${entry.action})`}</span>
                                <span className="remark-history-body">{entry.body}</span>
                            </div>
                        </div>
                    ))}
                    {entries.length === 0 && <p style={{ color: "#707070" }}>No approval comments available.</p>}
                </div>
            </Modal.Body>
        </Modal>
    );
}
